import "../styles.scss";

import { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { getPrivilegesRange, putPrivilegesRange } from "../../../../store/middleware";

function Privileges() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { affiliateAllPrivileges } = useSelector((state) => state.affiliateReducer);

  const [id, setId] = useState("");
  const [modal, setModal] = useState(false);
  const [range_min, setRange_min] = useState("");
  const [range_max, setRange_max] = useState("");
  const [description, setDescription] = useState("");

  const getData = () => dispatch(getPrivilegesRange());

  const handleSaveModal = () => {
    if (range_min === "" || range_max === "" || description === "") return;
    dispatch(putPrivilegesRange({ id, range_min, range_max, description })).then((resp) => resp && setModal(false));
  };

  const handleDataModal = (item) => {
    setId(item.id);
    setModal(true);
    setRange_min(item.range_min);
    setRange_max(item.range_max);
    setDescription(item.description);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="bigBoxTable">
        <table>
          <tbody>
            <tr>
              <th>{t("PRIVILEGES")}</th>
              <th style={{ textAlign: "center" }}>{t("VALUE")} Min</th>
              <th style={{ textAlign: "center" }}>{t("VALUE")} Max</th>
              <th style={{ textAlign: "right" }}>{t("OPTIONS")}</th>
            </tr>

            {affiliateAllPrivileges?.map((item) => (
              <tr key={item.id}>
                <td>{item.description}</td>
                <td style={{ textAlign: "center" }}>{item.range_min}</td>
                <td style={{ textAlign: "center" }}>{item.range_max}</td>
                <td>
                  <button onClick={() => handleDataModal(item)}>
                    {t("VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog
        open={modal}
        classes={"modalPrivilege"}
        className="modalPrivilege"
        onClose={() => setModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="contentModal">
          <h3 className="title">{t(description ? "EDIT" : "NEW") + " " + t("PRIVILEGE")}</h3>

          <form>
            <label className="labelModal">{t("PRIVILEGE")}</label>
            <input type="text" value={description} onChange={({ target }) => setDescription(target.value)} />

            <label className="labelModal">{t("VALUE")} Min</label>
            <input type="number" value={range_min} onChange={({ target }) => setRange_min(target.value)} />

            <label className="labelModal">{t("VALUE")} Max</label>
            <input type="number" value={range_max} onChange={({ target }) => setRange_max(target.value)} />
          </form>

          <div className="footer">
            <button className="buttonModalBack" onClick={() => setModal(false)}>
              {t("BACK")}
            </button>
            <button className="buttonModalSave" onClick={handleSaveModal}>
              {t("SAVE")}
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default Privileges;
